export default {
  LOAD_CAREER_IDEAS (state, payload) {
    state.careerIdeas = payload
  },
  LOAD_CONNECTIONS (state, payload) {
    state.connections = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/quest/vuex/mutations.js